module.exports = __webpack_public_path__ + "7816b411e37af613fb4e4a6692001989.png";